// Initialize Firebase
import 'services/firebase/init';
import './i18n';

import * as Sentry from '@sentry/react';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { router } from './router';
import { SENTRY_DSN } from './services/api/config';
import { isProduction } from './utils';

if (isProduction()) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router), Sentry.replayIntegration()],
    tracesSampleRate: 0.5,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.25,
    ignoreErrors: [
      'top.GLOBALS',
      'fb_xd_fragment',
      /amplitude is not defined/i,
      /The user aborted a request/i,
      /Non-Error promise rejection captured/i,
    ],
    denyUrls: [/graph\.facebook\.com/i, /connect\.facebook\.net\/en_US\/all\.js/i],
  });
}

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
